import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import store from "../../store";
import {useRouter} from "vue-router";
import {useRoute} from "vue-router";

import { defineComponent } from "vue";
import { MostlyCloudy, CollectionTag, DataBoard, Document, Notebook, Reading, ShoppingBag, Setting, Tickets, User, DocumentCopy, Postcard, Key, Grape } from "@element-plus/icons-vue";

const __default__ = defineComponent({
  name: "SidebarIndex",
  components: {
    MostlyCloudy, CollectionTag, DataBoard, Document, Notebook, Reading, ShoppingBag, Setting, Tickets, User, DocumentCopy, Postcard, Key, Grape,
  },
  data() {
    return {
      activeMenuIndex: this.$route.path,
    }
  },
});


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const isRoot = store.getters.root;
const rList = store.getters.routers;
const router = useRouter();
const route = useRoute();

const menuClick = (item: any) => {
  if (item.index === route.path) {
    router.push({path: '/admin/redirect', query: {next: item.index}});
  }
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_image, {
      style: {"width":"100px","height":"100px"},
      src: "/logo.png",
      fit: "fill"
    }),
    _createVNode(_component_el_menu, {
      router: true,
      "default-active": _ctx.activeMenuIndex
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, {
          index: `/admin/dashboard`,
          onClick: menuClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(DataBoard))
              ]),
              _: 1
            }),
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "总览", -1))
          ]),
          _: 1
        }),
        (_unref(isRoot) || _unref(rList).includes('/admin/question'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: `/admin/question`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(MostlyCloudy))
                  ]),
                  _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("span", null, "题库", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/test_papers'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: `/admin/test_papers`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Document))
                  ]),
                  _: 1
                }),
                _cache[2] || (_cache[2] = _createElementVNode("span", null, "试卷", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/grades'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 2,
              index: `/admin/grades`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Notebook))
                  ]),
                  _: 1
                }),
                _cache[3] || (_cache[3] = _createElementVNode("span", null, "年级", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/knowledge_points'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 3,
              index: `/admin/knowledge_points`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Reading))
                  ]),
                  _: 1
                }),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, "知识点", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/knowledge'))
          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 4,
              index: `/admin/knowledge`
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CollectionTag))
                  ]),
                  _: 1
                }),
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "学科", -1))
              ]),
              default: _withCtx(() => [
                (_unref(isRoot) || _unref(rList).includes('/admin/subjects'))
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 0,
                      index: `/admin/subjects`,
                      onClick: menuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Tickets))
                          ]),
                          _: 1
                        }),
                        _cache[6] || (_cache[6] = _createElementVNode("span", null, "学科", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(isRoot) || _unref(rList).includes('/admin/textbook'))
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 1,
                      index: `/admin/textbook`,
                      onClick: menuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Notebook))
                          ]),
                          _: 1
                        }),
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, "教材", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(isRoot) || _unref(rList).includes('/admin/chapter'))
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 2,
                      index: `/admin/chapter`,
                      onClick: menuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Grape))
                          ]),
                          _: 1
                        }),
                        _cache[8] || (_cache[8] = _createElementVNode("span", null, "章节", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/article'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 5,
              index: `/admin/article`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(DocumentCopy))
                  ]),
                  _: 1
                }),
                _cache[9] || (_cache[9] = _createElementVNode("span", null, "免费资源", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/members'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 6,
              index: `/admin/members`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(User))
                  ]),
                  _: 1
                }),
                _cache[10] || (_cache[10] = _createElementVNode("span", null, "用户", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot) || _unref(rList).includes('/admin/orders'))
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 7,
              index: `/admin/orders`,
              onClick: menuClick
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ShoppingBag))
                  ]),
                  _: 1
                }),
                _cache[11] || (_cache[11] = _createElementVNode("span", null, "订单", -1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_unref(isRoot))
          ? (_openBlock(), _createBlock(_component_el_sub_menu, {
              key: 8,
              index: `/admin/settings`
            }, {
              title: _withCtx(() => [
                _createVNode(_component_el_icon, null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Setting))
                  ]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createElementVNode("span", null, "设置", -1))
              ]),
              default: _withCtx(() => [
                (_unref(isRoot))
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 0,
                      index: `/admin/users/index`,
                      onClick: menuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Key))
                          ]),
                          _: 1
                        }),
                        _cache[13] || (_cache[13] = _createElementVNode("span", null, "账号管理", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_unref(isRoot))
                  ? (_openBlock(), _createBlock(_component_el_menu_item, {
                      key: 1,
                      index: `/admin/users/group`,
                      onClick: menuClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(Postcard))
                          ]),
                          _: 1
                        }),
                        _cache[14] || (_cache[14] = _createElementVNode("span", null, "权限分组", -1))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["default-active"])
  ], 64))
}
}

})